import { Box } from '@mui/material';
import { StepperComponent } from '../../components/stepper.component';
import {
	FirstStepComponent,
	SecondStepComponent,
	ThirdStepComponent,
	FourthStepComponent,
	ApprovedPublication,
} from '../../components/new-order-steps/sell';
import { useContext, useEffect, useState } from 'react';
import { asyncHandler } from '../../utils/async-handler';
import {
	CambiappContext,
	CambiappContextType,
} from '../../context/cambiapp.context';
import { ListingType } from '../../interfaces/publication.interface';
import { convertAppointmentTime } from '../../utils/date';
import moment from 'moment';

const NewPublication = () => {
	const {
		newSellOrder,
		selectedAvailableAppointments,
		orderAmr,
		expirationDate,
		currency,
	} = useContext(CambiappContext) as CambiappContextType;
	const [awaitResponse, setAwaitResponse] = useState(false);
	const [publishedPublication, setPublishedPublication] =
		useState<boolean>(false);
	const [activeStep, setActiveStep] = useState(0);
	const nextStep = () => {
		if (activeStep < 3) setActiveStep(activeStep + 1);
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	};
	const previousStep = () => {
		if (activeStep > 0) setActiveStep(activeStep - 1);
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	};
	const handlePublication = async () => {
		const {
			price,
			minimunPesos,
			firstBatch,
			secondBatch,
			isPartialAllowed,
			minimunPartialAmount,
		} = newSellOrder;
		if (price && minimunPesos && firstBatch) {
			setAwaitResponse(true);
			asyncHandler.publishNewOrder(
				{
					type: ListingType.SALE,
					unitPrice: price,
					minimumDenominationToReceive: minimunPesos.name,
					isArchived: false,
					isDiscarded: false,
					advanceMinimumRequired: orderAmr,
					listingBatches: secondBatch
						? [
								{
									amount: firstBatch.amount,
									billColor: firstBatch.version.color,
									billDenomination: `${firstBatch.denomination.name}-${firstBatch.denomination.value}`,
									billStatus: firstBatch.status.split('-')[1],
									billVersion: `${firstBatch.version.name}/${firstBatch.version.description}`,
								},
								{
									amount: secondBatch.amount,
									billColor: secondBatch.version.color,
									billDenomination: `${secondBatch.denomination.name}-${secondBatch.denomination.value}`,
									billStatus: secondBatch.status.split('-')[1],
									billVersion: `${secondBatch.version.name}/${secondBatch.version.description}`,
								},
						  ]
						: [
								{
									amount: firstBatch.amount,
									billColor: firstBatch.version.color,
									billDenomination: `${firstBatch.denomination.name}-${firstBatch.denomination.value}`,
									billStatus: firstBatch.status.split('-')[1],
									billVersion: `${firstBatch.version.name}/${firstBatch.version.description}`,
								},
						  ],
					listingShifts: await convertAppointmentTime(
						selectedAvailableAppointments,
					),
					expirationDate: moment(expirationDate).toDate(),
					isPartialAllowed,
					minimunPartialAmount,
					currency,
				},
				setPublishedPublication,
				previousStep,
			);
		}
	};
	useEffect(() => {
		publishedPublication && setActiveStep(4);
	}, [publishedPublication]);
	return (
		<Box sx={{ marginTop: '25px' }}>
			{publishedPublication && <ApprovedPublication />}
			{!publishedPublication && <StepperComponent activeStep={activeStep} />}
			{activeStep === 0 && <FirstStepComponent nextStep={nextStep} />}
			{activeStep === 1 && (
				<SecondStepComponent nextStep={nextStep} previousStep={previousStep} />
			)}
			{activeStep === 2 && (
				<ThirdStepComponent nextStep={nextStep} previousStep={previousStep} />
			)}
			{activeStep === 3 && (
				<FourthStepComponent
					awaitResponse={awaitResponse}
					previousStep={previousStep}
					nextStep={handlePublication}
				/>
			)}
		</Box>
	);
};

export default NewPublication;
